import { render, staticRenderFns } from "./VideoManager.vue?vue&type=template&id=6d04898e&scoped=true&"
import script from "./VideoManager.vue?vue&type=script&lang=js&"
export * from "./VideoManager.vue?vue&type=script&lang=js&"
import style0 from "./VideoManager.vue?vue&type=style&index=0&id=6d04898e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d04898e",
  null
  
)

export default component.exports